import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import store from './store'
import VueTelInput from 'vue-tel-input'
import VueFilterDateFormat from 'vue-filter-date-format';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as VueGoogleMaps from "vue2-google-maps"
import icons from "v-svg-icons";

Vue.use(Vant);
Vue.use(VueTelInput);
Vue.use(VueFilterDateFormat);
Vue.component("icon", icons);

Vue.use(Loading, {
  color: '#ee2d24',
  width: 64,
  height: 64,
  backgroundColor: '#ffffff',
  opacity: 0.5,
  zIndex: 999,
  canCancel: false
});

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCMMQUpLxj6CctCGKX12E7VBtHAkWIFp-4",
    libraries: "places" // necessary for places input
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
